import React, { useEffect } from 'react';
import _ from 'lodash';
import {
  Button, Form, Input, notification, message
} from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import * as Service from '../core/Service';
import { formItemLayout, tailLayout } from "./ModalLayout";

const AdminPassword = (props) => {
  const [form] = Form.useForm();
  const admin = useSelector((state) => state.app.admin);
  const { t } = useTranslation();

  useEffect(() => {
    form.resetFields();
  }, []);

  const onFinish = async (postObj) => {
    const admin_id = admin.admin_id;
    const { oldPassword, password } = postObj;

    let myPostObj = {
      ...postObj,
      admin_id,
      oldPassword,
      password,
    };
    myPostObj = _.pickBy(myPostObj, (value) => { return !_.isNull(value) });

    // Password check
    if (postObj.password !== postObj.re_password) {
      notification.error({
        message: 'Error',
        description:
          'Password not same, please input again',
      },);
      return;
    }

    let data = await Service.call('patch', '/api/admin/pw', myPostObj);
    if (data.errorMessage) {
      message.error(data.errorMessage);
      return props.openModal(true);
    }
    message.success(t('common_success'));
    return props.openModal(false);
  };


  return (
    <Form
      {...formItemLayout}
      form={form}
      name="time_related_controls"
      onFinish={onFinish}
      initialValues={admin}
      style={{maxHeight: "80vh", overflow: "auto"}}
    >
      <Form.Item
        label={t('common_email')}
        name="email"
        rules={[{ required: true }]}
      >
        <Input disabled={admin.email} />
      </Form.Item>
      <Form.Item
        label={t('common_old_password')}
        name="oldPassword"
        rules={[{ required: true }]}
      >
        <Input type="password" />
      </Form.Item>
      <Form.Item
        label={t('common_password')}
        name="password"
        rules={[{ required: true }]}
      >
        <Input type="password" />
      </Form.Item>
      <Form.Item
        label={t('common_password_retype')}
        name="re_password"
        rules={[{ required: true }]}
      >
        <Input type="password" />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button
          type="primary"
          htmlType="submit"
        >
          提交
        </Button>
      </Form.Item>
    </Form>
  )
}

export default AdminPassword;
